import { render, staticRenderFns } from "./ProductsCardExpense.vue?vue&type=template&id=d568cf32&scoped=true&"
import script from "./ProductsCardExpense.vue?vue&type=script&lang=js&"
export * from "./ProductsCardExpense.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCardExpense.vue?vue&type=style&index=0&id=d568cf32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d568cf32",
  null
  
)

export default component.exports